module.exports = __webpack_public_path__ + "static/media/preloader-Big-FC-withText-Flood.bd839635.gif";